import { Swiper } from 'swiper/bundle'

const advantagesSlider = document.querySelector('.advantagesSlider')
const breakpoint = window.matchMedia('(min-width: 768px)')
let advantagesSliderSwiper

const enableSwiper = function () {
	advantagesSliderSwiper = new Swiper('.advantagesSlider', {
		spaceBetween: 24,
		loop: true,
		slidesPerView: 1,
		speed: 600,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		breakpoints: {
			768: {
				slidesPerView: 1
			},
			1280: {
				slidesPerView: 2
			}
		}
	})
}

const breakpointChecker = function () {
	// If viewport is 768px or less
	if (!breakpoint.matches) {
		// Destroy swiper instance if it exists
		if (advantagesSliderSwiper !== undefined) {
			advantagesSliderSwiper.destroy(true, true)
			advantagesSliderSwiper = undefined // Clear the reference
		}
	} else {
		// Initialize swiper if it's not already initialized
		if (!advantagesSliderSwiper) {
			enableSwiper()
		}
	}
}

if (advantagesSlider) {
	breakpoint.addEventListener('change', breakpointChecker)
	breakpointChecker() // Call immediately to check initial state
}
